import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { RoutingFilterResponse } from './RoutingFilterTypes';

export { RoutingFilterResponse };

export interface IGetRoutingFiltersResult extends IResult {
  success?: {
    routingRules: RoutingFilterResponse[];
  };
}

export interface IGetRoutingFiltersParams {
  siteId: string;
}

export class GetRoutingFiltersRequest extends Request<IGetRoutingFiltersParams, IGetRoutingFiltersResult> {
  constructor(params: IGetRoutingFiltersParams) {
    super('getRoutingRules', params);
  }
}
